import { render, staticRenderFns } from "./wideImageBlock.vue?vue&type=template&id=1504ff60&"
import script from "./wideImageBlock.vue?vue&type=script&lang=js&"
export * from "./wideImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./wideImageBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports